var _path, _path2, _circle, _circle2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCryptocurrency(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6143 19.8307C35.9593 12.2584 30.0009 4.46671 21.751 6.21075M21.751 6.21075L24.6342 8.65836M21.751 6.21075L24.0426 3.55004",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15088 20.9668C4.80587 28.5391 10.7642 36.3308 19.0142 34.5868M19.0142 34.5868L16.131 32.1392M19.0142 34.5868L16.7225 37.2475",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.2502,
    cy: 27.3836,
    r: 8.33333,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5837,
    cy: 12.7173,
    r: 8.33333,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4301 12.3836C15.9695 11.9082 16.3106 11.2129 16.3106 10.4392C16.3106 9.35337 15.6394 8.4219 14.6903 8.03646V7.19844C14.6903 6.8405 14.4001 6.55029 14.0421 6.55029C13.6841 6.55029 13.394 6.8405 13.394 7.19844V7.84659H12.0977V7.19844C12.0977 6.8405 11.8075 6.55029 11.4495 6.55029C11.0915 6.55029 10.8014 6.8405 10.8014 7.19844V7.84659H9.50508C9.1471 7.84659 8.85693 8.1368 8.85693 8.49474C8.85693 8.85268 9.1471 9.14289 9.50508 9.14289H10.1532V12.3836V15.6244H9.50508C9.1471 15.6244 8.85693 15.9146 8.85693 16.2725C8.85693 16.6305 9.1471 16.9207 9.50508 16.9207H10.8014V17.5688C10.8014 17.9268 11.0915 18.217 11.4495 18.217C11.8075 18.217 12.0977 17.9268 12.0977 17.5688V16.9207H13.394V17.5688C13.394 17.9268 13.6841 18.217 14.0421 18.217C14.4001 18.217 14.6903 17.9268 14.6903 17.5688V16.7308C15.6394 16.3454 16.3106 15.4139 16.3106 14.3281C16.3106 13.5543 15.9695 12.8591 15.4301 12.3836ZM11.4495 9.14289H13.718C14.4328 9.14289 15.0143 9.7244 15.0143 10.4392C15.0143 11.154 14.4328 11.7355 13.718 11.7355H11.4495V9.14289ZM13.718 15.6244H11.4495V13.0318H13.718C14.4328 13.0318 15.0143 13.6133 15.0143 14.3281C15.0143 15.0429 14.4328 15.6244 13.718 15.6244Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.416667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 21.8839V32.8839M30.6875 23.5268H26.1923C25.5611 23.5268 24.9558 23.73 24.5095 24.0917C24.0632 24.4533 23.8125 24.9439 23.8125 25.4554C23.8125 25.9669 24.0632 26.4574 24.5095 26.8191C24.9558 27.1808 25.5611 27.3839 26.1923 27.3839H28.3077C28.6202 27.3839 28.9297 27.4338 29.2184 27.5307C29.5071 27.6277 29.7695 27.7697 29.9905 27.9488C30.2115 28.1279 30.3868 28.3405 30.5063 28.5745C30.6259 28.8085 30.6875 29.0593 30.6875 29.3125C30.6875 29.5658 30.6259 29.8166 30.5063 30.0505C30.3868 30.2845 30.2115 30.4971 29.9905 30.6762C29.7695 30.8553 29.5071 30.9974 29.2184 31.0943C28.9297 31.1912 28.6202 31.2411 28.3077 31.2411H23.8125",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptocurrency);
export default __webpack_public_path__ + "static/media/Cryptocurrency.7c711cd9d1476637125748eda49cd775.svg";
export { ForwardRef as ReactComponent };